import{gql as a}from"@apollo/client";import{GELADA_ORGANISATION_FRAGMENT as e}from"../../graphql/fragments/geladaOrganisation.fragment.js";const n=a`
  mutation createGeladaOrganisation(
    $description: String!
    $name: String!
    $shouldIncludeOrganisationLogo: Boolean = false
    $key: String!
    $logo: CreateAssetBaseInputType
  ) {
    organisation {
      createGeladaOrganisation: createOrganisation(
        organisation: { description: $description, name: $name, key: $key, url: $key, tag: $key }
        logo: $logo
      ) {
        ...geladaOrganisationFragment
      }
    }
  }

  ${e}
`;export{n as CREATE_GELADA_ORGANISATION_MUTATION};
//# sourceMappingURL=useCreateGeladaOrganisation.graphql.js.map
